import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	clickupStepLabel: {
		id: 'project-create-importer-upload-flow.common.utils.import-steps.clickup.clickup-step-label',
		defaultMessage: 'Select list',
		description: 'Label for ClickUp step in progress tracker',
	},
});
